
import { Table, TableBody } from "@/components/ui/table";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import StarRating from "@/components/StarRating";
import RatingRow from "@/components/RatingRow";
import { useIsMobile } from "@/hooks/use-mobile";

interface PartRatingProps {
  rating: number;
  sidebarExpanded?: boolean;
  gridLayout?: boolean;
  renderAsIndividualIcons?: boolean;
  onClick?: () => void;
  className?: string;
}

const PartRating = ({ 
  rating, 
  sidebarExpanded, 
  gridLayout = false, 
  renderAsIndividualIcons = false,
  onClick,
  className = ""
}: PartRatingProps) => {
  const isMobile = useIsMobile();
  
  if (rating <= 0) return null;
  
  return (
    <HoverCard openDelay={0}>
      <HoverCardTrigger asChild>
        <div className={`cursor-help inline-flex ${className}`} onClick={onClick}>
          <StarRating 
            rating={rating} 
            className={`${isMobile ? "scale-100" : "scale-75 origin-left"}`}
            gridLayout={gridLayout}
            renderAsIndividualIcons={renderAsIndividualIcons}
          />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="z-[200] w-auto">
        <Table className="w-full">
          <TableBody>
            <RatingRow rating={1} description="Not recommended - Worse than stock" />
            <RatingRow rating={2} description="Stock or equivalent to stock" />
            <RatingRow rating={3} description="Better than stock" />
            <RatingRow rating={4} description="Significant upgrade over stock" />
            <RatingRow rating={5} description="Top tier features and quality" />
            <RatingRow rating={5} description="Recommended - best all-round upgrade" isGreen={true} />
          </TableBody>
        </Table>
      </HoverCardContent>
    </HoverCard>
  );
};

export default PartRating;
